module.exports = __webpack_public_path__ + "img/31.70e9886.jpg";